const DIA_SEMANA_UI_A_BACKEND = {
    Lunes: "LUNES",
    Martes: "MARTES",
    Miércoles: "MIERCOLES",
    Jueves: "JUEVES",
    Viernes: "VIERNES",
    Sábado: "SABADO",
    Domingo: "DOMINGO",
};

const DIA_SEMANA_BACKEND_A_UI = Object.fromEntries(
    Object.entries(DIA_SEMANA_UI_A_BACKEND).map(([ui, backend]) => [backend, ui])
);

export const toBackendTime = (value) => {
    if (!value) return value;
    return /^\d{2}:\d{2}$/.test(value) ? `${value}:00` : value;
};

export const getEntityId = (entity) => entity?._id || entity?.id || entity;

export const getNombreCompleto = (entity, fallback = "Sin nombre") => {
    if (!entity || typeof entity !== "object") {
        return fallback;
    }
    return [entity.nombre, entity.apellido].filter(Boolean).join(" ") || entity.name || fallback;
};

export const formatSede = (sede) => {
    if (!sede || typeof sede !== "object") {
        return "Sede sin asignar";
    }
    return sede.nombre || "Sede sin asignar";
};

export const normalizeTurno = (turno) => ({
    id: getEntityId(turno),
    paciente: turno.paciente ? getNombreCompleto(turno.paciente, null) : null,
    pacienteId: getEntityId(turno.paciente),
    pacienteRaw: turno.paciente ?? null,
    sede: formatSede(turno.sede),
    fechaHora: turno.fechaHora,
    fechaHoraPropuesta: turno.fechaHoraPropuesta ?? null,
    propuestoPor: turno.propuestoPor ?? null,
    duracion: turno.duracion,
    costo: turno.costo || 0,
    estado: String(turno.estado || "").toLowerCase(),
    medicoId: getEntityId(turno.id_medico),
    servicios: Array.isArray(turno.servicios) ? turno.servicios : [],
});

export const normalizeSede = (sede) => ({
    id: getEntityId(sede),
    nombre: sede.nombre || "Sede sin nombre",
});

export const normalizeServicio = (servicio) => ({
    id: getEntityId(servicio),
    nombre: servicio.nombre || "Servicio sin nombre",
    tipoServicio: servicio.tipoServicio || "",
    duracionEnMinutos: servicio.duracionEnMinutos ?? null,
    costoConsulta: servicio.costoConsulta ?? null,
});

export const normalizeDisponibilidad = (disponibilidad) => ({
    id: getEntityId(disponibilidad),
    diaSemana: DIA_SEMANA_BACKEND_A_UI[disponibilidad.diaSemana] || disponibilidad.diaSemana,
    horaDesde: disponibilidad.horaDesde,
    horaHasta: disponibilidad.horaHasta,
    sedeId: getEntityId(disponibilidad.sede),
});

export const resolveMedico = (medicos, user) => {
    const userId = user?.medicoId || user?.id || user?._id;
    const username = user?.username?.toLowerCase();
    const displayName = user?.displayName?.toLowerCase();

    return (
        medicos.find((medico) => {
            const medicoId = getEntityId(medico);
            const usuario = medico.usuario;
            const usuarioId = getEntityId(usuario);
            const nombreCompleto = getNombreCompleto(medico, "").toLowerCase();

            return (
                medicoId === userId ||
                usuarioId === userId ||
                usuario?.username?.toLowerCase() === username ||
                nombreCompleto === displayName
            );
        }) || null
    );
};

export { DIA_SEMANA_UI_A_BACKEND };